<script>
export default {
    name: 'BaseSelect',

    props: {
        value: {
            type: String,
        },

        placeholder: {
            type: String,
            default: undefined
        },

        options: {
            type: Array
        }
    },

    data () {
        return {
            focused: false,
            uid: undefined
        }
    },

    mounted() {
        const inBrowser = typeof window !== 'undefined'
        if (inBrowser) {
            this.uid = 'select' + Math.random()
        }
    },
}
</script>

<template>
    <div class="base-select"
      :class="{
        'has-value': value && value.length,
        'focused': focused
      }">
        <label :for="`${uid}`">
            <div class="label-text">
                <slot name="label"/>
            </div>
        </label>
        <div class="select-wrapper">
            <div class="before">
                <slot name="before"/>
            </div>
            <select
              @focus="focused = true"
              @blur="focused = false"
              v-on="$listeners"
              :value="value"
              :id="`${uid}`"
              v-bind="$attrs">
                <option v-if="placeholder" hidden disabled selected value>{{ placeholder }}</option>
                <option v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                  v-bind="option">
                    {{ option.name }}
                </option>
            </select>
            <div class="after">
                <slot name="after"/>
            </div>
        </div>
    </div>
</template>
<style lang="stylus">
// @import '../assets/css/base.styl'

.base-select
    font-size 1.4em
    border-bottom 2px solid $AkGreyscaleMediumUltGrey

    label
        color $AkGreyscaleBlack
        font-weight bold
        font-size .8em
        padding-bottom .8em
        display inline-block

    .select-wrapper
        display flex
        align-items center
        width 100%
        font-size .95em
        line-height 1.43
        color $AkGreyscaleBlack
        background-color #fff

        select
            flex-grow 1
            flex-shrink 1
            padding .5em
            border 0
            min-width 0
            box-sizing border-box
            color $AkGreyscaleBlack
            font-family inherit
            font-size inherit
            background transparent

            &:focus
                outline 0

        option
            font-family inherit

    &.focused
        border-color $AkGreyscaleBlack

    &.base-select-small
        font-size 1.15em

        .label-text
            font-size .9em
</style>